import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'
import { request } from '../../../_network/request'
import { serviceConfigsURLs, billingAccountServicesURLs } from '../../../_network/apiUrls'
import MenuWrapper from './MenuWrapper'
import OpenStackServicesWrapper from '../manage_openstack_services/OpenStackServicesWrapper'
import UserInterfaceServicesWrapper  from '../manage_ui_services/UserInterfaceServicesWrapper'
import BillingWrapper from '../manage_billing/BillingWrapper'
import PricesWrapper from '../manage_prices/PricesWrapper'
import AccountsWrapper from '../manage_accounts/AccountsWrapper'
import BillingAnalyticsWrapper from '../manage_billing_analytics/BillingAnalyticsWrapper'
import InvoicesWrapper from '../manage_invoices/InvoicesWrapper'
import PaymentsWrapper from '../manage_payments/PaymentsWrapper'
import LatestNotificationsWrapper from '../../notifications/LatestNotificationsWrapper'

const SubscriptionEditWrapper = (props) => {
  const { clientSubscriptions, subscriptionGroupsData, subscriptionGroupNames, latestAlerts } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const menuExpandedWidth = 240
  const menuWidth = 76

  const account_id = useSelector(state => state.profile.account_id)
  const latest_alerts_expanded = useSelector(state => state.settings.latest_alerts_expanded)
  
  const [menuExpanded, setMenuExpanded] = useState( width >= constants.lgBreakpoint ? true : false )
  const [activeTab, setActiveTab] = useState(null)
  const [services, setServices] = useState([])
  const [billingServices, setBillingServices] = useState([])
  const [subscriptionServices, setSubscriptionServices] = useState([])
  const [subscriptionName, setSubscriptionName] = useState(null)
  const [supportedServiceConfigs, setSupportedServiceConfigs] = useState([])
  const [fetchServices, setFetchServices] = useState(1)
  const [showOpenStackServices, setShowOpenStackServices] = useState(false)
  const [showAdminUI, setShowAdminUi] = useState(false)
  const [showCustomerUI, setShowCustomerUi] = useState(false)
  const [showBillingService, setShowBillingService] = useState(false)
  const [billingServicesConfigurable, setBillingServicesConfigurable] = useState(false)

  const getSubscriptionGroupTitle = () => {
    const group = subscriptionGroupsData.find(item => item.group_name === 'openstack_admin')
    return group ? group.title.value: ''
  }

  const pageLabelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
    padding: '0px 0px 20px 20px',
  }

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    borderRadius: '20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  }

  useEffect(() => {
    const fetchServicesData = async () => {
      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceConfigs
      const request_data = { url, method: 'GET' }      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setServices(response.data)
      } else {
        setServices([])
      }
    }

    const fetchBillingServicesData = async () => {
      const url = constants.billing_url + '/' + billingAccountServicesURLs.getAccountServices
      const request_data = { url, method: 'GET', headers: { 'customer-account-id': account_id } }      
      const response = await request(request_data)

      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setBillingServices(response.data)
      } else {
        setBillingServices([])
      }
    }

    fetchServicesData()
    fetchBillingServicesData()
  }, [fetchServices, account_id])
  
  useEffect(() => {
    const fetchSupportedServiceConfigsData = async () => {
      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getSupportedServiceConfigs
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSupportedServiceConfigs(response.data)
      } else {
        setSupportedServiceConfigs([])
      }
    }

    fetchSupportedServiceConfigsData()
  }, [])

  useEffect(() => {
    const subscription = clientSubscriptions.find(item => item.package_group === 'openstack_admin')
    const subscription_services = (subscription && subscription.services) ? subscription.services : []

    const custom_admin_ui = subscription_services.find(item => item.service_type === 'frontend' && item.service === 'custom_admin_ui')
    setShowAdminUi(custom_admin_ui ? true : false)

    const custom_client_ui = subscription_services.find(item => item.service_type === 'frontend' && item.service === 'custom_client_ui')
    setShowCustomerUi(custom_client_ui ? true : false)

    const openstack_service = subscription_services.find(item => item.service_type === 'backend')
    const backup_service = subscription_services.find(item => item.service_type === 'backup')
    const ui_service = custom_admin_ui || custom_client_ui
    setShowOpenStackServices( ((openstack_service && ui_service) || backup_service) ? true : false )

    const billing_service = subscription_services.find(item => item.service_type === 'billing')
    setShowBillingService(billing_service ? true : false)

    setBillingServicesConfigurable((custom_admin_ui || custom_client_ui) ? false : true)

    setSubscriptionServices(subscription_services.filter(item => item.service_type === 'backend'))

    setSubscriptionName((subscription && subscription.package_name) ? subscription.package_name : null)
  }, [clientSubscriptions])
  
  return (
    <Box sx={{ padding: '40px 20px' }}>
      <Box sx={pageLabelStyle}>{getSubscriptionGroupTitle()}</Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: latest_alerts_expanded? 9 : 'grow' }}>
          <Box sx={wrapperStyle}>
            <Stack
              direction='row'
              alignItems='flex-start'
              justifyContent='flex-start'
              spacing={1}
            >
              <MenuWrapper
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                menuExpandedWidth={menuExpandedWidth}
                menuWidth={menuWidth}
                menuExpanded={menuExpanded}
                setMenuExpanded={setMenuExpanded}
                showOpenStackServices={showOpenStackServices}
                showAdminUI={showAdminUI}
                showCustomerUI={showCustomerUI}
                showBillingService={showBillingService}
              />
              <Box
                sx={{
                  width: menuExpanded ? `calc(100% - ${menuExpandedWidth}px)` : `calc(100% - ${menuWidth}px)`
                }}
              >
                {
                  activeTab === 'openstack_services' &&
                  <OpenStackServicesWrapper
                    services={services.filter(item => item.service_type === 'backend')}
                    billingServices={billingServices}
                    supportedServiceConfigs={supportedServiceConfigs}
                    showBillingService={showBillingService}
                    setFetchServices={setFetchServices}
                    subscriptionName={subscriptionName}
                  />
                }

                {
                  activeTab === 'user_interfaces' &&
                  <UserInterfaceServicesWrapper
                    services={services.filter(item => item.service_type === 'frontend')}
                    supportedServiceConfigs={supportedServiceConfigs}
                    showAdminUI={showAdminUI}
                    showCustomerUI={showCustomerUI}
                    setFetchServices={setFetchServices}
                  />
                }

                {
                  activeTab === 'billing_service' &&
                  <BillingWrapper
                    backendServices={services.filter(item => item.service_type === 'backend')}
                    billingServices={billingServices}
                    backendBillingServices={services.filter(item => item.service_type === 'billing')}
                    subscriptionServices={subscriptionServices}
                    supportedServiceConfigs={supportedServiceConfigs}
                    billingServicesConfigurable={billingServicesConfigurable}
                    setFetchServices={setFetchServices}
                    subscriptionGroupNames={subscriptionGroupNames}
                  />
                }

                {
                  activeTab === 'prices' &&
                  <PricesWrapper
                    billingServices={billingServices}
                    supportedServiceConfigs={supportedServiceConfigs}
                  />
                }

                {
                  activeTab === 'accounts' &&
                  <AccountsWrapper
                    billingServices={billingServices}
                  />
                }

                {
                  activeTab === 'billing' &&
                  <BillingAnalyticsWrapper
                    billingServices={billingServices}
                  />
                }

                {
                  activeTab === 'invoices' &&
                  <InvoicesWrapper />
                }

                {
                  activeTab === 'payments' &&
                  <PaymentsWrapper />
                }
              </Box>
            </Stack>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: latest_alerts_expanded? 3 : 'auto' }}>
          <LatestNotificationsWrapper latestAlerts={latestAlerts} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubscriptionEditWrapper